import styled from 'styled-components'

export const TouchIndicatorWrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  color: inherit;

  span {
    font-weight: 600;
    font-size: 1.1rem;
    margin-bottom: 0;
  }

  svg {
    width: 3.5rem;
    stroke: ${props => props.theme.color.secondaryIntense};
    margin-bottom: 1rem;
  }
`
